import { render, staticRenderFns } from "./AppMobile.vue?vue&type=template&id=218a0d76&scoped=true"
import script from "./AppMobile.vue?vue&type=script&lang=js"
export * from "./AppMobile.vue?vue&type=script&lang=js"
import style0 from "./AppMobile.vue?vue&type=style&index=0&id=218a0d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a0d76",
  null
  
)

export default component.exports